import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";

export function obterConfiguracaoBancos(listaBancos) {
  const base = obterConfiguracaoBase();

  return {
    ...base,
    add: obterConfiguracaoAdd(),
    edit: ObterConfiguracaoEditar(),
    delete: obterConfiguracaoDeletar(),
    columns: {
      nomeBanco: _obterColunaBanco(listaBancos),
      agencia: { title: "Agência", filter: false },
      contaCorrente: { title: "Conta corrente", filter: false },
      contato: { title: "Titular", filter: false },
    },
  };
}

function _obterColunaBanco(listaBancos) {
  const edicaoAbaBancos = {
    type: "list",
    config: { selectText: "Selecione...", list: listaBancos },
  };
  
  const colunaBanco = {
    title: "Banco",
    editor: edicaoAbaBancos,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return colunaBanco;
}
